import { Box, styled } from '@mui/material';

export const StyledActionsContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(6.4),
}));
